import React from 'react';
import { brands } from '../data/mock';

const BrandsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Top Mobile <span className="text-orange-600">Brands</span>
          </h2>
          <p className="text-gray-600">
            We offer the latest smartphones from all leading brands
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 flex items-center justify-center hover:bg-orange-50 hover:shadow-lg transition-all duration-300 cursor-pointer group border border-gray-200"
            >
              <div className="text-center">
                <div className="h-12 flex items-center justify-center mb-2">
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="max-h-10 max-w-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                  />
                </div>
                <p className="text-sm font-medium text-gray-700 group-hover:text-orange-600 transition-colors">
                  {brand.name}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 text-lg">
            <span className="font-semibold text-orange-600">And many more brands...</span> with thousands of models to choose from
          </p>
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
